import styled, { keyframes } from "styled-components"

const fade = keyframes`
  0% { opacity: 0 }
  100% { opacity: 1 }
`

export const VacancyWrapp = styled.div`
  background-color: #f7f5f0;
  min-height: 100vh;

  .vacancy {
    padding-top: 112px;
    padding-bottom: 64px;

    .vacancy-menu {
      .menu {
        margin-bottom: 16px;
        button {
          background-color: #fbfaf7;
          color: #28342f;
          font-size: 13px;
          font-weight: 700;
          padding: 0 14px;
          margin-right: 8px;
          margin-bottom: 10px;
          box-shadow: none;
          height: 36px;
          border-radius: 8px;
          border: 1px solid #e7e2d8;
          cursor: pointer;
          transition: border-color 0.2s ease, background 0.2s ease;

          &:hover {
            background: #ffffff;
            border-color: #b9c7b5;
          }
        }
      }
    }

    .spin-load {
      display: flex;
      justify-content: center;
      margin-top: 50px;
    }

    .content {
      display: grid;
      gap: 18px;
      grid-template-columns: minmax(280px, 34%) minmax(0, 1fr);
      justify-content: center;
      width: min(1120px, calc(100% - 48px));
      margin: 0 auto;

      .list-vacancy {
        max-height: calc(100vh - 180px);
        overflow: auto;
        padding-right: 8px;

        .vacancy-item {
          cursor: pointer;
          display: flex;
          background: #ffffff;
          box-shadow: none;
          border: 1px solid #e7e2d8;
          border-radius: 8px;
          padding: 14px;
          margin-bottom: 10px;
          transition: border-color 0.2s ease, transform 0.2s ease;

          &:hover {
            border-color: #b9c7b5;
            transform: translateY(-1px);
          }

          .logo-company {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 44px;
            height: 44px;
            margin-right: 12px;
            border: 1px solid #ebe6db;
            background: #fbfaf7;
            border-radius: 8px;
            flex-shrink: 0;

            img {
              max-width: 30px;
              max-height: 30px;
              object-fit: contain;
            }
          }

          .company-profile {
            margin: auto 0;

            h1 {
              font-size: 15px;
              color: #28342f;
              line-height: 1.35;
              margin-bottom: 2px;
            }

            p {
              font-size: 13px;
              color: #69716b;
              line-height: 1.4;
            }
          }
        }
      }

      .content-description {
        min-height: 520px;
        background: #ffffff;
        box-shadow: none;
        border: 1px solid #e7e2d8;
        border-radius: 8px;
        padding: 32px;
        color: #28342f;

        .content-none {
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 15px;
            font-weight: 400;
            letter-spacing: 0;
            color: #9a9f99;
        }

        
        .logo-company img {
            width: 48px;
            max-height: 48px;
            object-fit: contain;
        }

        .section-title {
          font-weight: 700;
          font-size: 17px;
          margin-top: 18px;
          margin-bottom: 8px;
        }
        .section-describe {
          text-align: left;
          color: #4d5550;
          font-size: 14px;
          line-height: 1.6;

          li {
            margin-bottom: 6px;
          }
        }

        .company-profile {
          p {
            color: #69716b;
            font-size: 14px;
          }
        }

        .animation-show {
          opacity: 1;
          animation: ${fade} 0.2s ease-in-out;
        }
        .link-register {
          margin-top: 24px;

          button {
            min-width: 150px;
            height: 38px;
            border: none;
            border-radius: 8px;
            text-align: center;
            cursor: pointer;
            font-weight: 700;
            background: #28342f;

            a {
              color: white;
            }

            &:hover {
              background: #5f7967;
            }
          }
        }
      }
      @media (max-width: 1000px) {
        width: min(100% - 32px, 720px);
        grid-template-columns: 1fr;

        .content-description {
          display: none;
        }
      }
    }
  }
`
